<template>
  <mdb-container fluid v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold">
          <strong>Reporte visitas</strong>
        </h2>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div class="
    view view-cascade
    narrower
    py-2
    mx-4
    mb-3
    d-flex
    justify-content-between
    align-items-center
  " style="
    margin-top: -2.25rem;
    background-color: #67a3cf;
    position: static;
  ">
            <span class="white-text" style="
      font-family: OpenSans-Bold;
      font-size: 16px;
      display: table;
      margin: 0 auto;
    ">Visitas registradas</span>

            <div class="text-right" style="margin-top: -10px; display: flex; float: right;">

              <mdb-popover
                trigger="click"
                placement="bottom"
                :options="{ boundary: 'window' }"
              >
                <!-- Contenido del menú -->
                <div slot="body" class="d-flex flex-column">
                  <mdb-btn
                    size="sm"
                    flat
                    class="text-left"
                    @click="exportFile('xlsx')"
                  >
                    <mdb-icon icon="file-excel" class="mr-2" />
                    Excel (.xlsx)
                  </mdb-btn>

                  <mdb-btn
                    size="sm"
                    flat
                    class="text-left"
                    @click="exportFile('csv')"
                  >
                    <mdb-icon icon="file-alt" class="mr-2" />
                    CSV (.csv)
                  </mdb-btn>
                </div>

                <!-- Botón único -->
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 style_BTN"
                >
                  <mdb-icon icon="download" />
                </mdb-btn>

              </mdb-popover>

            </div>
          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-left" responsive>
                  <tr>
                    <th scope="col">
                      Residente
                      <p>
                        <input type="text" class="inputClass" style="width: 85% !important" v-model="searchResident"
                          placeholder="Buscar residente" />
                      </p>
                    </th>
                    <th scope="col">
                      Invitado
                      <p>
                        <input type="text" style="width: 85% !important" class="inputClass" v-model="searchVisitant"
                          placeholder="Buscar invitado" />
                      </p>
                    </th>
                    <th scope="col">
                      Fecha de ingreso
                      <p>
                        <input type="text" readonly class="inputClass" style="width: 100% !important"
                          placeholder="Fechas de ingreso" :value="calendarData.dateRange.start != ''
                            ? calendarData.dateRange.start +
                            ' -- ' +
                            calendarData.dateRange.end
                            : ''
                            " @focus="showModal = true" />
                      </p>
                    </th>
                    <th scope="col">
                      Fecha de salida
                      <p>
                        <input type="text" readonly class="inputClass" style="width: 100% !important"
                          placeholder="Fechas de salida" :value="calendarData2.dateRange.start != ''
                            ? calendarData2.dateRange.start +
                            ' -- ' +
                            calendarData2.dateRange.end
                            : ''
                            " @focus="showModal2 = true" />
                      </p>
                    </th>
                    <th scope="col">
                      Vehículo
                      <p>
                        <input type="text" style="width: 85% !important" class="inputClass" v-model="searchCar"
                          placeholder="Buscar vehículo" />
                      </p>
                    </th>
                    <th scope="col">
                      Puerta de ingreso
                      <p>
                        <model-select :options="gatesList" v-model="gateModel" style="height: 37px"
                          placeholder="Selecciona una puerta" @select="getReportOfVisits"></model-select>
                      </p>
                    </th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body style="font-size: 8px !important">
                  <tr v-for="(item, index) in visitantsList" v-bind:key="index">
                    <!--RESIDENT DATA-->
                    <td v-if="item.testResident">
                      <span>{{
                        item.testResident.firstName +
                        " " +
                        item.testResident.lastName
                      }}</span>
                      <p v-show="isMe.frac == 'Club Tres Marias'">
                        Acción: {{ item.testResident.action }}
                      </p>
                      <!-- <p>Calle: {{item.testResident.testStreet.name+' #'+item.testResident.number}}</p>
                      <p>Zona: {{item.testResident.testStreet.testZone.name}}</p> -->
                    </td>
                    <td v-else>SIN REGISTRO</td>
                    <!--VISITANT DATA-->
                    <td v-if="item.firstName && item.lastName">
                      {{ item.firstName + " " + item.lastName }}
                      <p>Autorizó: {{ item.accredited }}</p>
                      <div class="py-1" v-show="item.file" @click="showPhoto(item.file.publicUrl)"
                        style="color: #3c8dbc; color: #3c8dbc; cursor: pointer">
                        Identificación
                      </div>
                      <div>
                        <img src="../../../static/tarjeta-de-visit.png" width="20px" />
                        {{ visitantType[item.visitantType] }}
                      </div>
                      <div v-if="item.providerTypeId" class="mt-2" style="font-size: 12px">
                        <mdb-icon icon="truck" />
                        {{ findProvider(item.providerTypeId) }}
                      </div>
                    </td>
                    <td v-else>SIN REGISTRO</td>
                    <!--DATE IN DATA-->
                    <td v-if="
                      item.timein && item.testGateArrival && item.userArrival
                    ">
                      <span>
                        <mdb-icon icon="calendar-alt" class="mt-0" />
                        {{ formatDate(item.timein) }}
                      </span>
                      <p>
                        <mdb-icon icon="clock" class="mt-0" />
                        {{ formatTime(item.timein) }}
                      </p>
                      <p>
                        <mdb-icon icon="road" class="mt-0" />
                        {{ item.testGateArrival.name }}
                      </p>
                      <p>
                        <mdb-icon icon="user-circle" class="mt-0" />
                        {{
                          item.userArrival.firstName +
                          " " +
                          item.userArrival.lastName
                        }}
                      </p>
                      <div>
                        <mdb-icon icon="arrow-alt-circle-right" />
                        {{
                          item.accessMode == "QR" || item.accessMode == "QR-BOT"
                            ? "Invitación QR"
                            : "Registro Manual"
                        }}
                      </div>
                      <div></div>
                    </td>
                    <td v-else>SIN REGISTRO</td>
                    <td>
                      <div v-if="item.timeout">
                        <span>
                          <mdb-icon icon="calendar-alt" class="mt-0" />
                          {{ formatDate(item.timeout) }}
                        </span>
                        <p>
                          <mdb-icon icon="clock" class="mt-0" />
                          {{ formatTime(item.timeout) }}
                        </p>
                        <p v-if="item.testGateDeparture">
                          <mdb-icon icon="road" class="mt-0" />
                          {{ item.testGateDeparture.name }}
                        </p>
                        <p v-if="item.userDeparture">
                          <mdb-icon icon="user-circle" class="mt-0" />
                          {{
                            item.userDeparture.firstName +
                            " " +
                            item.userDeparture.lastName
                          }}
                        </p>
                      </div>
                      <div v-else>SIN REGISTRO</div>
                    </td>
                    <td>
                      <div v-if="item.carbrand && item.color && item.plate">
                        <span>
                          <mdb-icon icon="car" class="mt-0" />
                          {{ item.carbrand.name }}
                        </span>
                        <p>
                          <mdb-icon icon="tag" class="mt-0" />
                          {{ item.plate }}
                        </p>
                        <p>
                          <mdb-icon icon="square" class="mt-0" />
                          {{ item.color.name }}
                        </p>
                      </div>
                      <div v-else>SIN REGISTRO</div>
                    </td>
                    <td>
                      <span v-if="item.comments">
                        <mdb-icon icon="file" class="mt-0" />
                        {{ item.comments }}
                      </span>
                      <span v-else>No hay comentarios disponibles</span>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />
            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
    <Loader v-show="isLoading" />

    <mdb-modal size="md" :show="showModal" @close="showModal = false">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff">Selecciona un rango de fechas de
          ingreso</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-row>
          <mdb-col md="12">
            <FunctionalCalendar :configs="calendarConfigs" v-model="calendarData"></FunctionalCalendar>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <div class="text-right mb-1" style="
              display: flex;
              position: relative;
              float: right;
              margin-left: auto;
            ">
            <!-- <mdb-btn
                  color="color-prev"
                  class="btn-prev Rectngulo-14"
                  @click="cleanDate1"
                >Cerrar</mdb-btn> -->
            <mdb-btn color="light-green" class="btn-prev Rectngulo-14" @click="cleanDate1">Limpiar</mdb-btn>
            <mdb-btn class="btn btn-next btn-color-next Rectngulo-14" @click="catchDate1">Filtrar</mdb-btn>
          </div>
        </mdb-row>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal size="md" :show="showModal2" @close="showModal2 = false">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff">Selecciona un rango de fechas de
          salida</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-row>
          <mdb-col md="12">
            <FunctionalCalendar :configs="calendarConfigs" v-model="calendarData2"></FunctionalCalendar>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <div class="text-right mb-1" style="
              display: flex;
              position: relative;
              float: right;
              margin-left: auto;
            ">
            <!-- <mdb-btn
                  color="color-prev"
                  class="btn-prev Rectngulo-14"
                  @click="cleanDate2"
                >Cerrar</mdb-btn> -->
            <mdb-btn color="light-green" class="btn-prev Rectngulo-14" @click="cleanDate2">Limpiar</mdb-btn>
            <mdb-btn class="btn btn-next btn-color-next Rectngulo-14" @click="catchDate2">Filtrar</mdb-btn>
          </div>
        </mdb-row>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { mapGetters, mapActions } from "vuex";
import Loader from "../../core/Loader";
import XLSX from "xlsx";
import { FunctionalCalendar } from "vue-functional-calendar";
import visitantType from "../../utils/visitantType";
import { ModelSelect } from "vue-search-select";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbPopover,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
} from "mdbvue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Visitants",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbPopover,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Loader,
    FunctionalCalendar,
    ModelSelect,
    Pagination,
  },
  data() {
    return {
      visitantType,
      showModal: false,
      showModal2: false,
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      visitantsList: [],
      perPage: 15,
      pages: [],
      dateSearchOut: "",
      dateSearch: "",
      calendarData: { dateRange: { start: "", end: "" } },
      calendarData2: { dateRange: { start: "", end: "" } },
      calendarConfigs: {
        sundayStart: true,
        dateFormat: "yyyy/mm/dd",
        isModal: false,
        isDateRange: true,
        calendarsCount: 1,
        disabledDates: ["afterToday"],
        dayNames: ["L", "M", "Mi", "J", "V", "S", "D"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        shortMonthNames: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
      },
      // optionsDate: {
      //   week: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
      //   month: [
      //     "Enero",
      //     "Febrero",
      //     "Marzo",
      //     "Abril",
      //     "Mayo",
      //     "Junio",
      //     "Julio",
      //     "Agosto",
      //     "Septiembre",
      //     "Octubre",
      //     "Noviembre",
      //     "Diciembre"
      //   ],
      //   buttons: {
      //     ok: "Aceptar",
      //     clear: "Limpiar",
      //     cancel: "Cancelar",
      //     today: "Hoy"
      //   },
      //   format: "DD-MM-YYYY"
      // },
      // limitDate: [
      //   {
      //     type: "fromto",
      //     from: "",
      //     to: "2100-12-30"
      //   }
      // ],
      listFilter: [],
      /////
      page: 1,
      numberOfPages: 0,
      isLoading: false,
      totalPages: 0,
      totalElements: 0,
      pageNumber: 1,
      searchResident: "",
      searchVisitant: "",
      dateTimeIn: "",
      dateTimeInEnd: "",
      searchCar: "",
      dateTimeOut: "",
      dateTimeOutEnd: "",
      gatesList: [],
      gateModel: {
        value: "",
        uuid: "",
        text: ""
      },
    };
  },
  methods: {
    ...mapActions(["getReports", "getReports2", "getReportCsv"]),
    async getGates() {
      let aux = this;
      let response = await Axios.get(Servers.serverApi + "api/gates", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      });
      this.gatesList = [];
      for (var i = 0; i < response.data.length; i++) {
        var temp = {
          value: response.data[i].idGate,
          uuid: response.data[i].uuid,
          text: response.data[i].name
        };
        this.gatesList.push(temp);
      }
    },
    findProvider(value) {
      let prov = this.providers.find((val) => val.id == value);
      if (prov) {
        return prov.name;
      } else {
        return "proveedor no registrado";
      }
    },
    catchDate1() {
      if (
        this.calendarData.dateRange.start != "" &&
        this.calendarData.dateRange.end != ""
      ) {
        this.dateFormatIn();
        this.showModal = false;
      } else {
        alert("Falta una fecha");
      }
    },
    cleanDate1() {
      this.calendarData = { dateRange: { start: "", end: "" } };
      this.dateTimeIn = "";
      this.dateTimeInEnd = "";
      this.showModal = false;
      this.page = 1;
      this.getReportOfVisits();
    },
    catchDate2() {
      if (
        this.calendarData2.dateRange.start != "" &&
        this.calendarData2.dateRange.end != ""
      ) {
        this.dateFormatOut();
        this.showModal2 = false;
      } else {
        alert("Falta una fecha");
      }
    },
    cleanDate2() {
      this.calendarData2 = { dateRange: { start: "", end: "" } };
      this.dateTimeOut = "";
      this.dateTimeOutEnd = "";
      this.showModal2 = false;
      this.page = 1;
      this.getReportOfVisits();
    },
    showPhoto(url) {
      Swal.fire({
        title: "Identificación",
        width: 550,
        padding: "3em",
        html:
          '<div<a data-caption="Image caption 1"  href="' +
          url +
          '"><img id="myimage" style="width: 100%;" src="' +
          url +
          '"></a></div>',
        showCancelButton: false,
        confirmButtonText: "Cerrar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6",
        reverseButtons: true,
        allowOutsideClick: false,
      });
    },
    makeExcel(list) {
      var newList = [];
      for (let i = 0; i < list.length; i++) {
        let auxJson = {
          residente:
            list[i].testResident && this.isMe.frac == "Club Tres Marias"
              ? list[i].testResident.firstName +
              " " +
              list[i].testResident.lastName +
              "\n Acción: " +
              list[i].testResident.action
              : list[i].testResident
                ? list[i].testResident.firstName +
                " " +
                list[i].testResident.lastName
                : "SIN REGISTRO",
          invitado:
            list[i].firstName && list[i].lastName
              ? list[i].firstName +
              " " +
              list[i].lastName +
              "\n Autorizo: " +
              list[i].accredited
              : "SIN REGISTRO",
          ingreso:
            list[i].timein && list[i].testGateArrival && list[i].userArrival
              ? this.dateIn(list[i].timein) +
              "\n" +
              this.timeIn(list[i].timein) +
              "\n" +
              list[i].testGateArrival.name +
              "\n Vigilante: " +
              list[i].userArrival.firstName +
              " " +
              list[i].userArrival.lastName
              : "SIN REGISTRO",
          salida:
            list[i].timeout &&
              list[i].testGateDeparture &&
              list[i].userDeparture
              ? this.dateIn(list[i].timeout) +
              "\n" +
              this.timeIn(list[i].timeout) +
              "\n" +
              list[i].testGateDeparture.name +
              "\n Vigilante: " +
              list[i].userDeparture.firstName +
              " " +
              list[i].userArrival.lastName
              : "SIN REGISTRO",
          vehículo:
            list[i].carbrand && list[i].color && list[i].plate
              ? list[i].carbrand.name +
              "\n" +
              list[i].plate +
              "\n" +
              list[i].color.name
              : "SIN REGISTRO",
        };
        newList.push(auxJson);
      }
      return newList;
    },
    exportFile(type) {
      if (type === 'xlsx') {
        this.exportExcel();
      } else {
        this.exportCsv();
      }
    },

    async exportExcel() {
      let params = { body: "" };

      if (this.dateTimeIn && this.dateTimeInEnd) {
        params.body += "&timeInFilter=" + this.dateTimeIn + "&timeInEndFilter=" + this.dateTimeInEnd;
      }
      if (this.searchVisitant) {
        params.body += "&nameFilter=" + this.searchVisitant;
      }
      if (this.searchResident) {
        params.body += "&residentFilter=" + this.searchResident;
      }
      if (this.dateTimeOut && this.dateTimeOutEnd) {
        params.body += "&timeOutFilter=" + this.dateTimeOut + "&timeOutEndFilter=" + this.dateTimeOutEnd;
      }
      if (this.searchCar) {
        params.body += "&vehicleFilter=" + this.searchCar;
      }
      if (this.gateModel.value != "") {
        params.body += "&idGateArrival=" + this.gateModel.value;
      }

      try {
        this.isLoading = true;
        let response = await this.getReportCsv(params);
        const rows = response.data;

        if (!Array.isArray(rows) || rows.length === 0) {
          this.isLoading = false;
          this.showMessageInfo("Sin datos", "No hay datos para descargar", "warning");
          return;
        }

        const dataTransform = this.makeExcel(rows);
        const worksheet = XLSX.utils.json_to_sheet(dataTransform);
        const workbook = XLSX.utils.book_new();
        const fileName = "reporte_visitas";
        XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: 'Error al exportar',
          text: error.response?.data?.message || 'No se pudo exportar el archivo.',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },

    async exportCsv() {
      let params = { body: "" };

      if (this.dateTimeIn && this.dateTimeInEnd) {
        params.body += "&timeInFilter=" + this.dateTimeIn + "&timeInEndFilter=" + this.dateTimeInEnd;
      }
      if (this.searchVisitant) {
        params.body += "&nameFilter=" + this.searchVisitant;
      }
      if (this.searchResident) {
        params.body += "&residentFilter=" + this.searchResident;
      }
      if (this.dateTimeOut && this.dateTimeOutEnd) {
        params.body += "&timeOutFilter=" + this.dateTimeOut + "&timeOutEndFilter=" + this.dateTimeOutEnd;
      }
      if (this.searchCar) {
        params.body += "&vehicleFilter=" + this.searchCar;
      }
      if (this.gateModel.value != "") {
        params.body += "&idGateArrival=" + this.gateModel.value;
      }

      try {
        this.isLoading = true;
        let response = await this.getReportCsv(params);
        const rows = response.data;

        if (!Array.isArray(rows) || rows.length === 0) {
          this.isLoading = false;
          this.showMessageInfo("Sin datos", "No hay datos para descargar", "warning");
          return;
        }

        const dataTransform = this.makeExcel(rows);
        const worksheet = XLSX.utils.json_to_sheet(dataTransform);
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "reporte_visitas.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: 'Error al exportar',
          text: error.response?.data?.message || 'No se pudo exportar el archivo.',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    dateIn(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1;

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var today = dd + "/" + mm + "/" + yyyy;
      return today;
    },
    timeIn(date) {
      var d = new Date(date);
      return d.toLocaleTimeString();
    },
    dateFormatOut() {
      var date1 = new Date(this.calendarData2.dateRange.start);
      var dd = date1.getDate();
      var mm = date1.getMonth() + 1;

      var yyyy = date1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date1 = yyyy + "-" + mm + "-" + dd;

      var date2 = new Date(this.calendarData2.dateRange.end);
      dd = date2.getDate();
      mm = date2.getMonth() + 1;

      yyyy = date2.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date2 = yyyy + "-" + mm + "-" + dd;

      this.dateTimeOut = date1;
      this.dateTimeOutEnd = date2;
      this.page = 1;
      this.getReportOfVisits();
    },
    dateFormatIn() {
      var date1 = new Date(this.calendarData.dateRange.start);
      var dd = date1.getDate();
      var mm = date1.getMonth() + 1;

      var yyyy = date1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date1 = yyyy + "-" + mm + "-" + dd;

      var date2 = new Date(this.calendarData.dateRange.end);
      dd = date2.getDate();
      mm = date2.getMonth() + 1;

      yyyy = date2.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date2 = yyyy + "-" + mm + "-" + dd;

      this.dateTimeIn = date1;
      this.dateTimeInEnd = date2;
      this.page = 1;
      this.getReportOfVisits();
    },

    getActiveTimeZone() {
      return (this.isMe && this.isMe.fracTimeZone) || undefined;
    },


    parseToUTCDate(value) {
      if (value == null) return null;
      if (typeof value === 'number') {
        return value < 1e12 ? new Date(value * 1000) : new Date(value);
      }
      if (typeof value === 'string') {
        let v = value.trim();
        const hasZone = /[zZ]|[+\-]\d{2}:\d{2}$/.test(v);
        if (!hasZone) v += 'Z';
        return new Date(v);
      }
      try { return new Date(value); } catch { return null; }
    },

    formatDate(date) {
      const d = this.parseToUTCDate(date);
      if (!d || isNaN(d)) return '—';
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: this.getActiveTimeZone(),
        day: '2-digit', month: '2-digit', year: 'numeric'
      }).format(d);
    },

    formatTime(date) {
      const d = this.parseToUTCDate(date);
      if (!d || isNaN(d)) return '—';
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: this.getActiveTimeZone(),
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }).format(d);
    },

    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showMessageError: function (text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => { },
      });
    },
    showMessageSucces: function () {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Correcto!</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => {
          window.location.reload();
        },
      });
    },
    showMessageInfo: function (text, subtitle, type = "warning") {
      Swal.fire({
        title: `<span style="font-size: 20px;">${text}</span>`,
        html: `<span style="font-size: 12px;">${subtitle}</span>`,
        icon: type, // ⬅️ SweetAlert2 usa icon, no type
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        }
      })
    },
    async getReportOfVisits() {
      let params = {};
      params.body = "page=" + this.page;
      if (this.dateTimeIn && this.dateTimeInEnd) {
        params.body =
          params.body +
          "&timeInFilter=" +
          this.dateTimeIn +
          "&timeInEndFilter=" +
          this.dateTimeInEnd;
      }
      if (this.searchVisitant) {
        params.body = params.body + "&nameFilter=" + this.searchVisitant;
      }
      if (this.searchResident) {
        params.body = params.body + "&residentFilter=" + this.searchResident;
      }
      if (this.dateTimeOut && this.dateTimeOutEnd) {
        params.body =
          params.body +
          "&timeOutFilter=" +
          this.dateTimeOut +
          "&timeOutEndFilter=" +
          this.dateTimeOutEnd;
      }
      if (this.searchCar) {
        params.body = params.body + "&vehicleFilter=" + this.searchCar;
      }
      if (this.gateModel.value != "") {
        params.body = params.body + "&idGateArrival=" + this.gateModel.value
      }
      // params.page = this.page
      // params.timeInFilter = this.dateTimeIn
      // params.timeInEndFilter = this.dateTimeInEnd
      // params.nameFilter = this.searchVisitant
      // params.residentFiler = this.searchResident
      // params.timeOutFilter = this.dateTimeOut
      // params.timeOutEndFilter = this.dateTimeOutEnd
      // params.vehicleFilter = this.searchCar

      try {
        this.isLoading = true;
        let response = await this.getReports2(params);
        if (response.data.status == 200) {
          this.isLoading = false;
          this.visitantsList = response.data.data;
          this.numberOfPages = response.data.totalPages;
          this.totalElements = response.data.totalElements;
          this.pageNumber = response.data.pageNumber;
          this.setPages();
        }
      } catch (error) {
        this.isLoading = false;
      }
    },
    async getproviders() {
      await this.$store.dispatch("getProvidersList");
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      this.getReportOfVisits(); // Llamada para actualizar los datos según la página seleccionada
    },
  },
  mounted() {
    this.isLoading = true;
    this.getReportOfVisits();
    this.getproviders();
    this.getGates()
  },
  created() { },
  watch: {
    calendarData() { },
    searchCar() {
      this.page = 1;
      this.getReportOfVisits();
    },
    searchResident() {
      this.page = 1;
      this.getReportOfVisits();
    },
    searchVisitant() {
      this.page = 1;
      this.getReportOfVisits();
    },
    gateModel() {
      this.page = 1;
      this.getReportOfVisits();
    },
    page() {
      this.getReportOfVisits();
    },
    // visitantsList() {
    //   //this.setPages();
    // },
    // dateTimeIn(value) {
    //   if (value) {
    //     var dd = value.slice(0, 2);
    //     var mm = value.slice(3, 5);
    //     var yyyy = value.slice(6, 10);
    //     this.dateSearch = yyyy + "-" + mm + "-" + dd;

    //   } else {
    //     this.dateSearch = "";
    //   }
    //    this.getVisitats();
    // },
    // dateTimeOut(value) {
    //   if (value) {
    //     var dd = value.slice(0, 2);
    //     var mm = value.slice(3, 5);
    //     var yyyy = value.slice(6, 10);
    //     this.dateSearchOut = yyyy + "-" + mm + "-" + dd;

    //   } else {
    //     this.dateSearchOut = "";
    //   }
    //   this.getVisitats();
    // }
  },
  computed: {
    ...mapGetters({
      isMe: "getWhoAmi",
      providers: "getProviders",
    }),
  },
};
</script>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 12px;
  color: #999999;
  opacity: 1;
  /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999999;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #999999;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table>tbody {
  text-align: left;
}

.table td {
  font-size: 10px !important;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.inputClass {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #dadce0;
  border-radius: 4px;
  background-color: transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 2rem;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.pagination--active {
  visibility: visible;
  background-color: #67a3cf !important;
}

.modal-content {
  width: 100%;
}
</style>

<style></style>